// extracted by mini-css-extract-plugin
export default {"warningRecommended":"style_warningRecommended__xIGt-","allowedFileText":"style_allowedFileText__OiUU5","maxFileSizeText":"style_maxFileSizeText__qfjqX"};